// Anything exported from this file is importable by other in-browser modules.

import { BehaviorSubject, ReplaySubject } from "rxjs";

/** object maintains the collections of state subjects to be created and updated through functions */
const stateSubjects = {};

/**
 * get subject based on stateName. if no subject exists, will create new subject. if no stateName
 * variable exists, will return null
 * @param {string} stateName name of state being tracked
 * @returns a ReplaySubject that is stored in a stateSubjects key
 */
export function getStateSubject(stateName = "") {
  let observableState = null;
  if (stateName && typeof stateName === "string") {
    if (!stateSubjects[stateName]) {
      stateSubjects[stateName] = new ReplaySubject(1);
    }
    observableState = stateSubjects[stateName];
    // console.log('observableState', observableState)
  }
  return observableState;
}

/**
 * broadcast a new state message to other modules. when persisted is true, will store data in local
 * storage as a string
 * @param {string} stateName name of state to broadcast message on
 * @param {Object} message new state message object
 */
export function updateStateSubject(stateName = "", message = null) {
  const observable = getStateSubject(stateName);
  if (observable && observable.next) {
    observable.next(message);
  }
}

/**
 * create a subscription to global state
 * @param {string} stateName name of state
 * @param {Function} updateCallback callback to invoke with message
 * @returns subscription to particular global state changes
 */
export function createStateSubscription(stateName = "", updateCallback = null) {
  let subscription = null;
  const stateSubject = getStateSubject(stateName);
  if (
    typeof stateSubject?.subscribe === "function" &&
    typeof updateCallback === "function"
  ) {
    subscription = stateSubject.subscribe((updatedState) =>
      updateCallback(updatedState)
    );
  }
  return subscription;
}

/**
 * destroy a subscription
 * @param {Subscription} subscription
 */
export const destroyStateSubscription = (subscription) => {
  if (typeof subscription?.unsubscribe === "function") {
    subscription.unsubscribe();
  }
};
